'use client'

import React, { useState } from 'react'

import { useQuery } from '@apollo/client'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import {
  ContactUsSection,
  EmajinCorporateMembershipPackagesSection,
  ExploreIndividualMembershipSection,
  FAQSection,
  MembershipPointsSection,
  MembershipsCorporateHeroSection,
  TeeOffCorporateMembershipPackagesSection,
  TestimonialsSection,
} from 'Components/Sections'
import { Column, Loader } from 'Components/UI'
import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'

import {
  AllMembershipFeaturesDocument,
  MembershipFeatureModelOrderBy,
  MembershipsCorporatePageDocument,
} from 'GraphQL/DatoCMS/TypedDocuments'

function MembershipsCorporatePage() {
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  const { data: membershipsCorporatePageData, loading } = useQuery(
    MembershipsCorporatePageDocument,
    {
      context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
    },
  )

  const { data: allMembershipFeaturesData } = useQuery(
    AllMembershipFeaturesDocument,
    {
      variables: { orderBy: [MembershipFeatureModelOrderBy.PriorityAsc] },
      context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
    },
  )

  if (loading) return <Loader fullScreen size={32} />

  return (
    <Column alignCenter fullWidth>
      <MembershipsCorporateHeroSection
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <EmajinCorporateMembershipPackagesSection
        secondary
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <MembershipPointsSection
        secondary
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <TeeOffCorporateMembershipPackagesSection
        features={allMembershipFeaturesData?.allMembershipFeatures}
        packages={
          membershipsCorporatePageData?.membershipsCorporatePage
            ?.membershipPackages
        }
        secondary
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <ContactUsSection
        pb={[10, 10, 10, 16]}
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <ExploreIndividualMembershipSection />

      <TestimonialsSection
        data={
          membershipsCorporatePageData?.membershipsCorporatePage?.testimonials
        }
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <FAQSection
        data={membershipsCorporatePageData?.membershipsCorporatePage?.faq}
      />

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default MembershipsCorporatePage
